import { Tooltip as ReactTooltip } from 'react-tooltip';
import styled from 'styled-components';

const Tooltip = ({ ...props }) => {
  return <StyledTooltip {...props} />;
};

const StyledTooltip = styled(ReactTooltip)`
  box-shadow:
    0px 1px 2px 0px #0000001a,
    0px 9px 5px 0px #0000000d,
    0px 16px 6px 0px #00000003,
    0px 25px 7px 0px #00000000;
`;

export default Tooltip;
